import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  // Check if both black and white are out of stock
  const isOutOfStock = () => {
    if (!product.colorVariants) return false;
    
    const hasBlack = product.colors.includes('black');
    const hasWhite = product.colors.includes('white') || product.colors.includes('White');
    
    // Only show out of stock if both black and white exist and both are unavailable
    if (hasBlack && hasWhite) {
      const blackAvailable = product.colorVariants['black']?.available;
      const whiteAvailable = product.colorVariants['white']?.available || product.colorVariants['White']?.available;
      return !blackAvailable && !whiteAvailable;
    }
    
    return false;
  };

  // Add cache-busting for Cloudinary images
  const getImageUrl = (url) => {
    if (url && url.includes('cloudinary.com')) {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}t=${Date.now()}`;
    }
    return url;
  };

  return (
    <div className="product-card fade-in">
      <Link to={`/product/${product.id}`} className="product-link">
        <div className="product-image" style={{ backgroundImage: `url(${getImageUrl(product.image)})` }}>
          {product.stock < 10 && (
            <span className="badge low-stock">Low Stock</span>
          )}
          {isOutOfStock() && (
            <span className="badge out-of-stock">Out of Stock</span>
          )}
        </div>
        <div className="product-info">
          <h3 className="product-name">{product.name}</h3>
          <p className="product-description">{product.description}</p>
          
          {/* Color availability indicators */}
          {product.colorVariants && (
            <div className="color-indicators">
              {product.colors.map(color => {
                const available = product.colorVariants[color] && product.colorVariants[color].available;
                return (
                  <span 
                    key={color}
                    className={`color-dot ${!available ? 'unavailable' : ''}`}
                    style={{ backgroundColor: color }}
                    title={`${color} ${available ? 'available' : 'not available'}`}
                  >
                    {!available && <span className="cross">✕</span>}
                  </span>
                );
              })}
            </div>
          )}
          
          <div className="product-footer">
            <span className="product-price">₹{product.price}</span>
            <button className="btn-quick-view">View Details</button>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
